export enum ACTION {
    TRIGGER_METER_READING
}
